import { render, staticRenderFns } from "./MtCollectsModal.Style#Drawer.vue?vue&type=template&id=a84c3166&scoped=true&"
import script from "./MtCollectsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./MtCollectsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./MtCollectsModal.Style#Drawer.vue?vue&type=style&index=0&id=a84c3166&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84c3166",
  null
  
)

export default component.exports